import { LoginTemplate } from "../../components/template/loginTemplates";
import { LoginForm } from "../../components/organisms/LoginForm";

const LoginPage = (props: any) => {
  return (
    <LoginTemplate>
      <LoginForm {...props} />
    </LoginTemplate>
  );
};

export default LoginPage;
